module.exports = __webpack_public_path__ + "img/icon_muyu_download_code.f23fe08c.png";